<template>
    <div>
        <ion-grid>
            <ion-row class="search-view">
                <ion-col>
                    <ion-label>Branch Name</ion-label>
                    <div class="border-line-34 readonly margin-top-10">
                        <ion-input class="form-input" readonly="true" v-model="branchDetails.branch" placeholder="branch name"/>
                    </div>
                </ion-col>
                <ion-col>
                    <ion-label>Station Name</ion-label>
                    <div class="border-line-34 readonly margin-top-10">
                        <ion-input class="form-input" readonly="true" v-model="branchDetails.stationName" placeholder="station name"/>
                    </div>
                </ion-col>
                <!-- <ion-col>
                    <ion-label>Select Station</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                            class="form-select select-mobile"
                            v-model="selectedStation"
                            @ionChange="changeStation($event)"
                            placeholder=""
                            interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(station, index) in stations" 
                            :key="index" 
                            :value="station.id"
                        >{{ station.name }}</ion-select-option>
                        </ion-select>

                        <select
                            v-model="selectedStation"
                            class="input-select select-web"
                            placeholder=""
                            @change="changeStation($event)"
                        >
                        <option
                            v-for="(station, index) in stations" 
                            :key="index" 
                            :value="station.id"
                        >{{ station.name }}</option>
                        </select>
                    </div>
                </ion-col> -->

                <ion-col>
                    <ion-label>Select Charger Type</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                        class="form-select select-mobile"
                        v-model="selectedCharger"
                        @ionChange="changeCharger($event)"
                        placeholder="Select Report Type"
                        interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(charger, index) in chargers" 
                            :key="index" 
                            :value="charger.chargerId"
                        >{{ charger.chargerTypeDescription }}</ion-select-option>
                        </ion-select>

                        <select
                        v-model="selectedCharger"
                        class="input-select select-web"
                        placeholder="Select Status"
                        @change="changeCharger($event)"
                        >
                        <option
                            v-for="(charger, index) in chargers" 
                            :key="index" 
                            :value="charger.chargerId"
                        >{{ charger.chargerTypeDescription }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col>
                    <ion-label>Select Output</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                        class="form-select select-mobile"
                        v-model="selectedOutput"
                        @ionChange="changeOutput($event)"
                        placeholder="Select Report Type"
                        interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(output, index) in outputs" 
                            :key="index" 
                            :value="output.outputId"
                        >{{ output.outputName }}</ion-select-option>
                        </ion-select>

                        <select
                        v-model="selectedOutput"
                        class="input-select select-web"
                        placeholder="Select Status"
                        @change="changeOutput($event)"
                        >
                        <option
                            v-for="(output, index) in outputs" 
                            :key="index" 
                            :value="output.outputId"
                        >{{ output.outputName }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col>
                    <ion-label>From Date</ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                        <datepicker
                        class="form-vue-picker"
                        inputFormat="dd/MMM/yyyy"
                        placeholder="DD/MON/YYYY"
                        v-model="reportFrom"
                        :typeable="true"
                        :lowerLimit ="sixMonthsAgo"
                        :upperLimit ="currentDate"
                        ></datepicker>
                        <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                        <datepicker 
                        v-model="reportFrom" 
                        inputFormat="dd/MMM/yyyy"
                        class="form-picker" 
                        placeholder="Select From Date"
                        @change="fromDateChanged($event)"
                        :value = reportFrom
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="currentDate"
                        :typeable="true"
                        />
                        <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                </ion-col>
                <ion-col>
                    <ion-label>To Date</ion-label>
                    <div class="date-picker-box margin-top-10 datepicker-web">
                        <datepicker
                        class="form-vue-picker"
                        inputFormat="dd/MMM/yyyy"
                        placeholder="DD/MON/YYYY"
                        v-model="reportTo"
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="maxDate"
                        :typeable="true"
                        ></datepicker>
                        <span class="custom-calendar-icon">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                    <div class="border-line-34 margin-top-10 datepicker-mobile">
                        <datepicker 
                        v-model="reportTo" 
                        inputFormat="dd/MMM/yyyy"
                        class="form-picker" 
                        placeholder="Select To Date"
                        @change="reportTo = $event.target.value"
                        :value = reportTo
                        :lowerLimit="sixMonthsAgo"
                        :upperLimit="currentDate"
                        />
                        <span class="input-icon-calendar">
                        <img src="/../assets/images/common/datepicker/calendar.png" />
                        </span>
                    </div>
                </ion-col>
                
            </ion-row>
            <ion-row class="search-view">
                <ion-col>
                    <ion-label>Report Type</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-select
                        class="form-select select-mobile"
                        v-model="selectedReport"
                        @ionChange="changeType($event)"
                        placeholder="Select Report Type"
                        interface="action-sheet"
                        >
                        <ion-select-option
                            v-for="(types, index) in typesofReport" 
                            :key="index" 
                            :value="types.code"
                        >{{ types.description }}</ion-select-option>
                        </ion-select>

                        <select
                        v-model="selectedReport"
                        class="input-select select-web"
                        placeholder="Select Status"
                        @change="changeType($event)"
                        >
                        <option
                            v-for="(types, index) in typesofReport" 
                            :value="types.code"
                            :key="index"
                        >{{ types.description }}</option>
                        </select>
                    </div>
                </ion-col>
                <ion-col v-if="selectedReport === 'UB'">
                    <ion-label>Mobile No</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-input 
                        class="form-input" 
                        v-model="mobile"
                        type="text" 
                        id="mobile" 
                        @input="mobile = $event.target.value">
                        </ion-input>
                    </div>
                </ion-col>
                <ion-col v-if="selectedReport === 'VB'">
                    <ion-label>Vehicle No</ion-label>
                    <div class="border-line-34 margin-top-10">
                        <ion-input 
                        class="form-input" 
                        v-model="vehicle"
                        type="text" 
                        id="vehicle" 
                        @input="vehicle = $event.target.value">
                        </ion-input>
                    </div>
                </ion-col>
                <ion-col v-if="displayDownloadOption">
                    <div class="export-report">
                        <ion-label style="font-size: 14px;">Export Report</ion-label>
                        <div class="border-line-34 margin-top-10">
                            <ion-select
                                class="form-select select-mobile"
                                :value="reportType"
                                @ionChange="changeReportType($event)"
                                placeholder="Export Report"
                                interface="action-sheet"
                            >
                                <ion-select-option
                                    v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</ion-select-option>
                            </ion-select>

                            <select
                                @change="changeReportType($event)"
                                class="input-select select-web"
                                v-model="reportType"
                                placeholder="Export Report"
                            >
                                <option
                                v-for="(report, index) in this.reportTypes"
                                :key="index"
                                :value="report.code"
                                >{{report.name}}</option>
                            </select>
                        </div>
                    </div>
                </ion-col>
                <ion-col>
                    <div class="btn-srch-clr">
                        <ion-button class="btn-search " @click="searchReport">Search</ion-button>
                        <ion-button class="btn-clear " @click="clearFields">
                            <ion-icon :icon="refresh"></ion-icon>
                        </ion-button>
                    </div>
                </ion-col>
                <ion-col></ion-col>
            </ion-row><br>
            <!-- <ion-row v-if="displayDownloadOption">
                <ion-col size="6"></ion-col>
                <ion-col size="6">
                    
                </ion-col>
            </ion-row> -->
            <ion-row class="list-view" v-if="displayOverAllReport">
                <ion-col v-if="selectedReport === 'UB'">
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="2">
                        <ion-label>S. No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Mobile No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>Total kWh</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(report, index) in this.overAllPageData" :key="index">
                        <ion-col size="12" size-md="2">
                        <ion-label class="ext-link">{{ report.sNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2" style="cursor: pointer;" @click="addMobileInFilter(report.mobile)">
                        <ion-label>{{report.name }}</ion-label>
                        </ion-col>
                    
                        <ion-col size="12" size-md="2" style="cursor: pointer;" @click="addMobileInFilter(report.mobile)">
                        <ion-label>{{report.mobile}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                        <ion-label>{{report.totalkWh}}</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row class="totalSection">
                        <ion-col size="12" size-md="2"></ion-col>
                        <ion-col size="12" size-md="2"></ion-col>
                        <ion-col size="12" size-md="2" style="font-weight: bold;"><ion-label>Total kWh</ion-label></ion-col>
                        <ion-col size="12" size-md="2" ><ion-label>{{ overAllReport.totalKwh }}</ion-label> </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="list-view" v-if="displayUserBasedReport">
                <ion-col v-if="displayUserBasedReport">
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="0.5">
                        <ion-label>S. No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>Mobile</ion-label>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="1">
                        <ion-label>Vehicle Name</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="1">
                        <ion-label>Vehicle No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>Start Date & Time</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>End Date & Time</ion-label>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="1.5">
                        <ion-label>Inv.#</ion-label>
                        </ion-col> -->
                        <!-- <ion-col size="12" size-md="1">
                        <ion-label>Inv.Date</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="1">
                        <ion-label>Time Completed</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>Reason</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="0.5">
                        <ion-label>kWh</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(report, index) in this.userBasedPageData" :key="index">
                        <ion-col size="12" size-md="0.5">
                        <ion-label class="ext-link">{{ report.sNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>{{report.name}}</ion-label>
                        </ion-col>
                    
                        <ion-col size="12" size-md="1.5">
                        <ion-label>{{report.mobile}}</ion-label>
                        </ion-col>
                         <!-- <ion-col size="12" size-md="1">
                        <ion-label>{{report.vehicleMake }}</ion-label>
                        </ion-col> -->
                         <ion-col size="12" size-md="1">
                        <ion-label>{{report.vehicleNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>{{(report.startDateTime)}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>{{(report.endDateTime)}}</ion-label>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="1.5">
                        <ion-label>{{(report.invoiceNumber)}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1">
                        <ion-label>{{(report.invoiceDate)}}</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="1">
                        <ion-label>{{ report.timeCompleted }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>{{report.reason}}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1">
                        <ion-label>{{report.kWh}}</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row class="totalSection">
                        <ion-col size="8.5"></ion-col>
                        <ion-col size="1.5">
                            <ion-label>Total kWh </ion-label>
                        </ion-col>
                        <ion-col size="1.5">
                            <ion-label>{{ userBasedReport.totalKwh }}</ion-label>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
            <ion-row class="list-view" v-if="vehicleInd && displayOverAllReport" >
                <ion-col v-if="selectedReport === 'VB'">
                    <ion-row class="list-head">
                        <ion-col size="12" size-md="2">
                            <ion-label>S. No</ion-label>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="3">
                            <ion-label>Vehicle Name</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="3">
                            <ion-label>Vehicle No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>Total kWh</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(value,index) in overAllPageData" :key="index">
                        <ion-col size="12" size-md="2">
                            <ion-label class="ext-link">{{ value.sNo }}</ion-label>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="3" @click="addVehicleNo(value.vehicleNo)">
                            <ion-label>{{ value.vehicleMake }}</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="3" style="cursor: pointer;" @click="addVehicleNo(value.vehicleNo)">
                            <ion-label>{{ value.vehicleNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="3">
                            <ion-label>{{ value.totalkWh }}</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row class="totalSection">
                        <ion-col size="12" size-md="3"></ion-col>
                        <ion-col size="12" size-md="2" style="font-weight: bold;"><ion-label>Total kWh</ion-label></ion-col>
                        <ion-col size="12" size-md="2" ><ion-label>{{ overAllReport.totalKwh }}</ion-label> </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>

            <ion-row class="list-view" v-if="this.invidualVhDetails">
                <ion-col>
                    <ion-row class="list-head" >
                        <ion-col size="12" size-md="0.5">
                            <ion-label>S. No</ion-label>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="2">
                            <ion-label>Vehicle Name</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="1">
                            <ion-label>Vehicle No</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>Name</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1">
                            <ion-label>Mobile</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>Start Date&Time</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>End Date&Time</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                        <ion-label>Time Completed</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>Reason</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>Total kWh</ion-label>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row class="list-item" v-for="(userVal,index) in userBasedPageData" :key="index">
                        <ion-col size="12" size-md="0.5">
                            <ion-label class="ext-link">{{ userVal.sNo }}</ion-label>
                        </ion-col>
                        <!-- <ion-col size="12" size-md="2">
                            <ion-label>{{ userVal.vehicleMake }}</ion-label>
                        </ion-col> -->
                        <ion-col size="12" size-md="1">
                            <ion-label>{{ userVal.vehicleNo }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>{{ userVal.name }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1">
                            <ion-label>{{ userVal.mobile }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>{{ userVal.startDateTime }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>{{ userVal.endDateTime }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>{{ userVal.timeCompleted }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="2">
                            <ion-label>{{ userVal.reason }}</ion-label>
                        </ion-col>
                        <ion-col size="12" size-md="1.5">
                            <ion-label>{{ userVal.kWh }}</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row class="totalSection">
                        <ion-col size="12" size-md="9"></ion-col>
                        <ion-col size="12" size-md="1.5" style="font-weight: bold;"><ion-label>Total kWh</ion-label></ion-col>
                        <ion-col size="12" size-md="1.5" ><ion-label>{{ userBasedReport.totalKwh }}</ion-label> </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>

        <div>
            <ion-grid v-if="showGrid">
                <ion-row v-if="norecordsfound">
                    <ion-col size="12" class="ion-text-center no-records">
                    <ion-label class="pagination-info txt-color">No records found for the selected filters</ion-label>
                    </ion-col>
                </ion-row>
                <ion-row v-else>
                    <ion-col size="12" size-md="5">
                    <ion-label
                        class="pagination-info"
                    >Showing {{((pageRecords * pageNo) <= totalRecords) ? (pageRecords * pageNo) : totalRecords}} of {{totalRecords}} results</ion-label>
                    </ion-col>
                    <ion-col size="12" size-md="7" class="ion-text-right">
                    <div class="pagination">
                        <a class="prev" v-if="this.pageNo > 1" @click="loadPage(pageNo - 1)">Prev</a>
                        <a class="prev disabled" v-else>Prev</a>
                        <a
                        v-for="page in this.pagesList"
                        :key="page"
                        v-bind:class="{'active': pageNo == page}"
                        @click="loadPage(page)"
                        >{{page}}</a>
                        <a
                        class="next"
                        v-if="this.pageNo < this.totalPages"
                        @click="loadPage(pageNo + 1)"
                        >Next</a>
                        <a class="next disabled" v-else>Next</a>
                    </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>        
</template>

<script>
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonRow, IonSelect, IonSelectOption, IonSpinner} from "@ionic/vue";
import { defineComponent } from "vue";
import { receiptOutline, refresh, thumbsUpSharp, volumeLow } from 'ionicons/icons';
import datepicker from 'vue3-datepicker';
import moment from "moment";
import { ToastUtils } from "../../util/toast-utils";
import { CorporateService } from "../../service/corporate/corporate.service";
import { migratedTryParseServiceError } from "../../service";
import { ValidationUtils } from "../../util/validation-utils";
import { PaginationUtils } from "../../util/pagination-utils";
import jsonToCsvExport from "json-to-csv-export";

export default defineComponent({
    name: 'usageReport',
    components:{
        IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonIcon, IonGrid, IonRow, IonCol, IonSpinner, IonButton, IonLabel, datepicker, IonInput, IonSelect, IonSelectOption
    },
    
    data(){
        return{
            branchDetails: '',
            receiptOutline,
            refresh,
            loaderTab: true,
            reportFrom: new Date(),
            reportTo: new Date(),
            configDays: 0,
            configMonths: 0,
            // Calculate the minimum and maximum dates
            // minDate: this.calculateMinDate(),
            maxDate: new Date(), // Current date
            // The current date
            currentDate: new Date(),
            // Date 6 months ago
            sixMonthsAgo: new Date(),
            pageData: [],
            norecordsfound: true,
            totalRecords: 0,
            pageRecords: 10,
            pageNo: 1,
            pagesList: [],
            totalPages: 0,
            branchId: "",
            mobile: '',
            branchList: [],
            displayUserBasedReport: false,
            displayOverAllReport: false,
            userBasedReport: [],
            overAllReport: [],
            userBasedPageData: [],
            overAllPageData: [],
            reportTypes: [
                {
                    "name" : "PDF",
                    "code" : "pdf"
                },
                {
                    "name" : "CSV",
                    "code" : "csv"
                }
            ],
            reportType: "",
            displayDownloadOption: false,
            configValue: [],
            types : "",
            vehicleInd: false,
            // selectReportType: {
            //     typesofReport: [
            //         {
            //             "name" : "Usage Type",
            //             "code" : "UT"
            //         },
            //         {
            //             "name" : "Vehicle Type",
            //             "code" : "VT"
            //         }
            //     ],
            //     defaultType: 0
            // },
            selectedReport: "",
            typesofReport: [],
            vehicleDetails:[
                {
                    "sno": 1,
                    "name": "TATA MOTOR",
                    "regNo": "TN37HH5252",
                    "kWh": 0.7
                },
                {
                    "sno": 2,
                    "name": "Ather 450",
                    "regNo": "TN34LH5252",
                    "kWh": 1.2
                }
            ],
            vehicle: "",
            invidualVhDetails: false,
            showGrid: true,
            userRoleId: "",
            selectedStation: null,
            selectedCharger: "0",
            stations: [],
            chargers: [],
            outputs: [
                { outputId: "0", outputName: "All Outputs" }
            ],
            selectedOutput: "0",
            chargerName: "",
            outputName: ""
        }
    },
    async mounted() {
        this.userRoleId = window.localStorage.getItem("user.roleId");
        let response = await new CorporateService().getTypesOfReport();
        this.typesofReport = response.typesOfReport;
        this.selectedReport = response.typesOfReport[response.defaultType].code;

        // this.selectedStation = await new CorporateService().getStationDetails();
        // this.selectedCharger = await new CorporateService().getChargerDetails();

        // console.log(this.selectedReport)
        // this.selectedReport = this.selectReportType.typesofReport[this.selectReportType.defaultType];
  
        // let getStation = JSON.parse(localStorage.getItem("branchList"))
        // alert(getStation)

        // this.branchName = this.$route.params.branchInfo
        // alert(JSON.stringify(this.$route.params));

        // this.reportFrom = moment().subtract(30, 'days').format('YYYY-MM-DD');
        // this.reportTo = moment().format('YYYY-MM-DD');
        this.branchDetails = JSON.parse(localStorage.getItem('branchInfoFromReportList'));
        this.chargers = await new CorporateService().getChargerStatusDataForReport({
            branchId: this.branchDetails.branchId,
            stationId: this.branchDetails.stationId
        });
        if(this.chargers.length == 1) {
            this.selectedCharger = this.chargers?.[0]?.chargerId;
            this.chargers.filter((val) => {
                if(val.chargerId == this.selectedCharger) {
                    
                    this.chargerName = val.chargerTypeDescription;
                }
            });
            this.outputs = await new CorporateService().getChargerOutputListForReport({
                branchId: this.branchDetails.branchId,
                stationId: this.branchDetails.stationId,
                chargerId: this.selectedCharger,
            });
            this.selectedOutput = this.outputs?.[0]?.outputId;
            this.outputs.filter((val) => {
                if(val.outputId == this.selectedOutput) {
                    
                    this.outputName = val.outputName;
                }
            });
        } else {
            this.selectedCharger = this.chargers?.[0]?.chargerId;
            this.selectedOutput = this.outputs?.[0]?.outputId;
            this.chargers.filter((val) => {
                if(val.chargerId == this.selectedCharger) {
                    
                    this.chargerName = val.chargerTypeDescription;
                }
            });
            this.outputs.filter((val) => {
                
                if(val.outputId == this.selectedOutput) {
                    
                    this.outputName = val.outputName;
                }
            });
        }
        
        await this.getDateAndMonth()
        await this.getDateDaysAgo(this.configDays)
        await this.getDateMonthsAgo(this.configMonths)
        // await this.getBranchListForChart();
        await this.searchReport();
        // await this.latestSearchReport();
    },
    
    methods: {
        changeStation(event) {
            this.selectedStation = event.target.value;
        },
        async changeCharger(event) {
            this.selectedCharger = event.target.value;
            this.chargers.filter((val) => {
                if(val.chargerId == this.selectedCharger) {
                    
                    this.chargerName = val.chargerTypeDescription;
                }
            });
            this.outputs = await new CorporateService().getChargerOutputListForReport({
                branchId: this.branchDetails.branchId,
                stationId: this.branchDetails.stationId,
                chargerId: this.selectedCharger,
            });
            this.selectedOutput = this.outputs?.[0]?.outputId;
            this.outputs.filter((val) => {
                if(val.outputId == this.selectedOutput) {
                    this.outputName = val.outputName;
                }
            });
            this.displayDownloadOption = false;
            this.invidualVhDetails = false;
            this.displayOverAllReport = false;
            this.vehicleInd = false;
            this.displayUserBasedReport = false;
            this.overAllPageData = "";
            this.userBasedPageData = "";
            this.showGrid = false;
        },
        changeOutput(event) {
            this.selectedOutput = event.target.value;
             this.outputs.filter((val) => {
                if(val.outputId == this.selectedOutput) {
                    this.outputName = val.outputName;
                }
            });
            this.displayDownloadOption = false;
            this.invidualVhDetails = false;
            this.displayOverAllReport = false;
            this.vehicleInd = false;
            this.displayUserBasedReport = false;
            this.overAllPageData = "";
            this.userBasedPageData = "";
            this.showGrid = false;
        },
        async changeType(event) {
            this.selectedReport = event.target.value;
            this.displayDownloadOption = false;
            this.invidualVhDetails = false;
            this.displayOverAllReport = false;
            this.vehicleInd = false;
            this.displayUserBasedReport = false;
            this.overAllPageData = "";
            this.userBasedPageData = ""
            this.mobile = "";
            this.vehicle = "";
            this.norecordsfound = true;
            this.showGrid = false
        },
        async getDateAndMonth() {
            this.configValue = await new CorporateService().getConfigValueOfDateAndMonth()
            this.configDays = this.configValue[0].description;
            this.configMonths = this.configValue[1].description
        },
        calculateMinDate() {
            const date = new Date();
            date.setMonth(date.getMonth() - 6);
            // alert(date)
            return date;
        },
        fromDateChanged(event) {
            // alert(event)
        },
        // Helper function to calculate a date 'n' days ago
        async getDateDaysAgo(days) {
            const date = new Date();
            date.setDate(date.getDate() - days);

            this.reportFrom =  date;
        },

        // Helper function to calculate the date 'n' months ago
        async getDateMonthsAgo(months) {
            const date = new Date();
            date.setMonth(date.getMonth() - months);
            this.sixMonthsAgo = date;
        },
        changeDateFormat(dateValue) {
            // return moment(dateValue).format('DD/MMM/YYYY HH:mm')
            return dateValue;
        },
        async changeBranchName(event) {
            this.branchId = event.target.value;
        },
        
        addMobileInFilter(mobile) {
            document.getElementById('mobile').value = mobile;
            this.mobile = mobile;
        },
        addVehicleNo(vehicle) {
            document.getElementById('vehicle').value = vehicle;
            this.vehicle = vehicle;
        },
        
        async getBranchListForChart() {
            this.branchList = [];
            this.loaderTab = true;
            try {
                this.branchList =  await new CorporateService().getBranchList();

                // this.branchId = this.branchList[0].branchId;
                this.branchId = this.branchList.length == 1 ? this.branchList[0].branchId : 'All'
                this.loaderTab = false;
                // this.getChargerStatus(this.branchId);
            } catch(error) {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        
        },
        async latestSearchReport() {
            this.showGrid = true
            this.loaderTab = true;
            this.pageNo = 1;
            this.pageRecords = 10;
            this.reportType = "";
            this.displayDownloadOption = false;
            let d1 = moment(this.reportTo)
            let d2 = moment(this.reportFrom);
            let d3 = d1.diff(d2, 'days');
            let dateRange =  (new Date(this.reportTo) - new Date(this.reportFrom));
            let dateRangeBetween = dateRange/(1000*60*60*24)
            if(this.reportFrom &&
                this.reportTo &&
                new Date(this.reportFrom) > new Date(this.reportTo)){
                this.loaderTab = false;
                new ToastUtils().presentToast("Please select correct date range of Reoprt. From date should less than To date");
                this.displayUserBasedReport = false;
                this.displayOverAllReport = false;
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                this.loaderTab = false;
            } else if(d3 > this.configDays) {
                // alert(this.reportFrom + this.reportTo)
                this.loaderTab = false;
                new ToastUtils().presentToast("Please select valid date range. The report can be viewed for a maximum of "+ this.configDays + " days");
                this.displayUserBasedReport = false;
                this.displayOverAllReport = false;
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                this.loaderTab = false;
            } else {

                const selectedType = this.typesofReport.find(
                    type => type.code === this.selectedReport
                );


                if (!selectedType) {
                    this.loaderTab = false;
                    new ToastUtils().presentToast("Please select Report Type");
                    return;
                }
                const params = {
                    branchId: this.branchDetails.branchId,
                    fromDate: moment(this.reportFrom).format("YYYY-MM-DD"),
                    toDate: moment(this.reportTo).format("YYYY-MM-DD"),
                    reportTypeCode: this.selectedReport,
                    stationId: this.branchDetails.stationId,
                    chargerId: this.selectedCharger,
                    chargerType: this.chargerName,
                    outputName: this.outputName,
                    branchName: this.branchDetails.branch,
                    stationName: this.branchDetails.stationName,
                };
                // Reset
                this.vehicleInd = false;
                this.invidualVhDetails = false;

                // Set based on report configuration
                this.vehicleInd = selectedType.displayType === "vehicle";
                if (!this.mobile && !this.vehicle) {

                    this.overAllReport = await new CorporateService().getUsageReportQuery(params);
                    const reportData = this.overAllReport?.reportData || [];
                    if (reportData.length > 0) {
                        this.totalRecords = reportData.length;
                        this.pagesList = new PaginationUtils().getPagesList(
                            this.totalRecords,
                            this.pageRecords,
                            this.pageNo
                        );

                        this.totalPages = new PaginationUtils().getTotalPages(
                            this.totalRecords,
                            this.pageRecords
                        );

                        const to = this.pageRecords * this.pageNo;
                        const from = this.pageRecords * (this.pageNo - 1);

                        this.overAllPageData = reportData.slice(from, to);

                        this.displayUserBasedReport = false;
                        this.displayOverAllReport = true;
                        this.displayDownloadOption = true;
                        this.norecordsfound = false;

                    } else {
                        this.overAllPageData = [];
                        this.displayUserBasedReport = false;
                        this.displayOverAllReport = false;
                        this.displayDownloadOption = false;
                        this.norecordsfound = true;
                    }
                    this.loaderTab = false;
                    return;
                }

                /*
                * Individual report
                */

                // If mobile is entered
                if (this.mobile) {

                    if (new ValidationUtils().mobile(this.mobile) === false) {
                        new ToastUtils().presentToast("Enter Valid Mobile Number");
                        return;
                    }

                    params.mobile = this.mobile;
                }

                // If vehicle is entered
                if (this.vehicle) {
                    params.vehicleNo = this.vehicle;
                }

                this.userBasedReport = await new CorporateService().getUsageReportQuery(params);
                const reportData = this.userBasedReport?.reportData || [];

                if (reportData.length > 0) {
                    this.totalRecords = reportData.length;
                    this.pagesList = new PaginationUtils().getPagesList(
                        this.totalRecords,
                        this.pageRecords,
                        this.pageNo
                    );

                    this.totalPages = new PaginationUtils().getTotalPages(
                        this.totalRecords,
                        this.pageRecords
                    );

                    const to = this.pageRecords * this.pageNo;
                    const from = this.pageRecords * (this.pageNo - 1);

                    this.userBasedPageData = reportData.slice(from, to);

                    this.displayUserBasedReport = true;
                    this.displayOverAllReport = false;
                    this.displayDownloadOption = true;
                    this.norecordsfound = false;

                } else {

                    this.userBasedPageData = [];

                    this.displayUserBasedReport = false;
                    this.displayOverAllReport = false;
                    this.displayDownloadOption = false;
                    this.norecordsfound = true;
                }
                this.loaderTab = false;
            }
        },
        async searchReport() {
            this.showGrid = true
            this.loaderTab = true;
            this.pageNo = 1;
            this.pageRecords = 10;
            this.reportType = "";
            this.displayDownloadOption = false;
            let d1 = moment(this.reportTo)
            let d2 = moment(this.reportFrom);
            let d3 = d1.diff(d2, 'days');
            let dateRange =  (new Date(this.reportTo) - new Date(this.reportFrom));
            let dateRangeBetween = dateRange/(1000*60*60*24)
            if(this.reportFrom &&
                this.reportTo &&
                new Date(this.reportFrom) > new Date(this.reportTo)){
                this.loaderTab = false;
                new ToastUtils().presentToast("Please select correct date range of Reoprt. From date should less than To date");
                this.displayUserBasedReport = false;
                this.displayOverAllReport = false;
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                this.loaderTab = false;
            } else if(d3 > this.configDays) {
                // alert(this.reportFrom + this.reportTo)
                this.loaderTab = false;
                new ToastUtils().presentToast("Please select valid date range. The report can be viewed for a maximum of "+ this.configDays + " days");
                this.displayUserBasedReport = false;
                this.displayOverAllReport = false;
                this.displayDownloadOption = false;
                this.norecordsfound = true;
                this.loaderTab = false;
            } else if(this.selectedReport == "UB") {
                if(!this.mobile){
                    try {
                        this.overAllReport = await new CorporateService().getUsageReportQuery({
                            branchId: this.branchDetails.branchId,
                            fromDate: moment(this.reportFrom).format('YYYY-MM-DD'),
                            toDate: moment(this.reportTo).format('YYYY-MM-DD'),
                            reportTypeCode: this.selectedReport,
                            stationId: this.branchDetails.stationId,
                            chargerId: this.selectedCharger,
                            outputId: this.selectedOutput,
                            branchName: this.branchDetails.branch,
                            stationName: this.branchDetails.stationName,
                            chargerType: this.chargerName,
                            outputName: this.outputName
                        });
                        if(this.overAllReport.reportData.length > 0) {
                            this.totalRecords = this.overAllReport.reportData.length;
                            (this.pagesList = new PaginationUtils().getPagesList(
                            this.totalRecords,
                            this.pageRecords,
                            this.pageNo
                            )),
                            (this.totalPages = new PaginationUtils().getTotalPages(
                                this.totalRecords,
                                this.pageRecords
                            ));
                            let to = this.pageRecords*this.pageNo;
                            let from = (this.pageRecords * (this.pageNo -1));
                            this.overAllPageData = this.overAllReport.reportData.slice(from, to)
                            this.displayUserBasedReport = false;
                            this.displayOverAllReport = true;
                            this.displayDownloadOption = true;
                            this.norecordsfound = false;
                        } else {
                            this.displayUserBasedReport = false;
                            this.displayOverAllReport = false;
                            this.norecordsfound = true;
                            this.displayDownloadOption = false;
                        }
                        this.loaderTab = false;
                    } catch(error) {
                        this.loaderTab = false;
                        let serviceError = migratedTryParseServiceError(error);
                        new ToastUtils().presentToast(serviceError.description);
                    }   
                } else if(new ValidationUtils().mobile(this.mobile) === false){
                    new ToastUtils().presentToast("Enter Valid Mobile Number");
                    this.loaderTab = false;
                } else {
                    try {
                        this.userBasedReport = await new CorporateService().getUsageReportQuery({
                            mobile: this.mobile,
                            branchId: this.branchDetails.branchId,
                            fromDate: moment(this.reportFrom).format('YYYY-MM-DD'),
                            toDate: moment(this.reportTo).format('YYYY-MM-DD'),
                            reportTypeCode: this.selectedReport,
                            stationId: this.branchDetails.stationId,
                            chargerId: this.selectedCharger,
                            outputId: this.selectedOutput,
                            chargerType: this.chargerName,
                            outputName: this.outputName,
                            branchName: this.branchDetails.branch,
                            stationName: this.branchDetails.stationName,
                        });
                        if(this.userBasedReport.reportData.length > 0) {
                            this.totalRecords = this.userBasedReport.reportData.length;
                            (this.pagesList = new PaginationUtils().getPagesList(
                            this.totalRecords,
                            this.pageRecords,
                            this.pageNo
                            )),
                            (this.totalPages = new PaginationUtils().getTotalPages(
                                this.totalRecords,
                                this.pageRecords
                            ));
                            let to = this.pageRecords*this.pageNo;
                            let from = (this.pageRecords * (this.pageNo -1));
                            this.userBasedPageData = this.userBasedReport.reportData.slice(from, to)
                            this.displayUserBasedReport = true;
                            this.displayOverAllReport = false;
                            this.norecordsfound = false;
                            this.displayDownloadOption = true;
                        } else {
                            this.displayUserBasedReport = false;
                            this.displayOverAllReport = false;
                            this.norecordsfound = true;
                            this.displayDownloadOption = false;
                        }
                        this.loaderTab = false;
                    } catch(error) {
                        this.loaderTab = false;
                        let serviceError = migratedTryParseServiceError(error);
                        new ToastUtils().presentToast(serviceError.description);
                    } 
                } 
            } else if(this.selectedReport == "VB") {
                
                if(!this.vehicle){
                    try {
                        this.overAllReport = await new CorporateService().getUsageReportQuery({
                            branchId: this.branchDetails.branchId,
                            fromDate: moment(this.reportFrom).format('YYYY-MM-DD'),
                            toDate: moment(this.reportTo).format('YYYY-MM-DD'),
                            reportTypeCode: this.selectedReport,
                            stationId: this.branchDetails.stationId,
                            chargerId: this.selectedCharger,
                            outputId: this.selectedOutput,
                            chargerType: this.chargerName,
                            outputName: this.outputName,
                            branchName: this.branchDetails.branch,
                            stationName: this.branchDetails.stationName,
                        });
                        // console.log(this.overAllReport)
                        if(this.overAllReport.reportData.length > 0) {
                            this.totalRecords = this.overAllReport.reportData.length;
                            (this.pagesList = new PaginationUtils().getPagesList(
                            this.totalRecords,
                            this.pageRecords,
                            this.pageNo
                            )),
                            (this.totalPages = new PaginationUtils().getTotalPages(
                                this.totalRecords,
                                this.pageRecords
                            ));
                            let to = this.pageRecords*this.pageNo;
                            let from = (this.pageRecords * (this.pageNo -1));
                            this.overAllPageData = this.overAllReport.reportData.slice(from, to)
                            this.vehicleInd = true;
                            // console.log(this.overAllPageData)
                            this.displayUserBasedReport = false;
                            this.displayOverAllReport = true;
                            this.displayDownloadOption = true;
                            this.norecordsfound = false;
                        } else {
                            this.displayUserBasedReport = false;
                            this.displayOverAllReport = false;
                            this.norecordsfound = true;
                            this.displayDownloadOption = false;
                        }
                        this.loaderTab = false;
                    } catch(error) {
                        this.loaderTab = false;
                        let serviceError = migratedTryParseServiceError(error);
                        new ToastUtils().presentToast(serviceError.description);
                    }   
                // } else if(new ValidationUtils().mobile(this.mobile) === false){
                //     new ToastUtils().presentToast("Enter Valid Mobile Number");
                //     this.loaderTab = false;
                } else {
                    try {
                        this.userBasedReport = await new CorporateService().getUsageReportQuery({
                            vehicleNo: this.vehicle,
                            branchId: this.branchDetails.branchId,
                            fromDate: moment(this.reportFrom).format('YYYY-MM-DD'),
                            toDate: moment(this.reportTo).format('YYYY-MM-DD'),
                            reportTypeCode: this.selectedReport,
                            stationId: this.branchDetails.stationId,
                            chargerId: this.selectedCharger,
                            outputId: this.selectedOutput,
                            chargerType: this.chargerName,
                            outputName: this.outputName,
                            branchName: this.branchDetails.branch,
                            stationName: this.branchDetails.stationName,
                        });
                        if(this.userBasedReport.reportData.length > 0) {
                            this.totalRecords = this.userBasedReport.reportData.length;
                            (this.pagesList = new PaginationUtils().getPagesList(
                            this.totalRecords,
                            this.pageRecords,
                            this.pageNo
                            )),
                            (this.totalPages = new PaginationUtils().getTotalPages(
                                this.totalRecords,
                                this.pageRecords
                            ));
                            let to = this.pageRecords*this.pageNo;
                            let from = (this.pageRecords * (this.pageNo -1));
                            this.userBasedPageData = this.userBasedReport.reportData.slice(from, to)
                            // this.displayUserBasedReport = true;
                            this.vehicleInd = false;
                            this.invidualVhDetails = true;
                            this.displayOverAllReport = false;
                            this.norecordsfound = false;
                            this.displayDownloadOption = true;
                        } else {
                            this.displayUserBasedReport = false;
                            this.displayOverAllReport = false;
                            this.norecordsfound = true;
                            this.displayDownloadOption = false;
                        }
                        this.loaderTab = false;
                    } catch(error) {
                        this.loaderTab = false;
                        let serviceError = migratedTryParseServiceError(error);
                        new ToastUtils().presentToast(serviceError.description);
                    } 
                } 
            }
        },
        async changeReportType(event) {
            let type = event.target.value;
            if(type == 'pdf') {
                if(this.displayOverAllReport) {
                    this.downloadPdf(this.overAllReport)
                } else {
                    this.downloadPdf(this.userBasedReport)
                }
            } else if(type == 'csv') {
                if(this.displayOverAllReport) {
                    this.downloadCSV(this.overAllReport)
                } else {
                    this.downloadCSV(this.userBasedReport)
                }
            }
        },
        async downloadCSV(reportDate) {
            if(this.userRoleId == 1 || this.userRoleId == 4) {
                try {
                    jsonToCsvExport({ data: reportDate.downloadingReportData.csv,headers: reportDate.reportHeaders.csvHeader, filename: "UsageReport_"+moment().format("DD/MM/YYYY")+".csv" })  // Automatically triggers download
                    this.reportType = ""
                } catch (error) {
                    console.error('Error generating CSV:', error);
                }
            } else {
                new ToastUtils().presentToast("You cannot download the reports");
            }
            
        },
        async downloadPdf(data) {
            if(this.userRoleId == 1 || this.userRoleId == 4) {
                try {
                    this.loaderTab = true;
                    const response = await new CorporateService().downloadUsagePdfReport(data, this.branchDetails.branchId,this.branchDetails.reportCode, this.selectedReport);
                    // Create a URL for the blob (PDF file)
                    const pdfBlob = response.data;
                    const pdfUrl = window.URL.createObjectURL(pdfBlob);
                    var a = document.createElement("a");
                    a.href = pdfUrl;
                    a.setAttribute("download", "UsageReport_"+moment().format("DD/MM/YYYY")+".pdf");
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    this.loaderTab = false;
                    this.reportType = ""
                } catch(error) {
                    this.loaderTab = false;
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
            } else {
                new ToastUtils().presentToast("You cannot download the reports");
            }
            
        },
        async clearFields() {
            this.reportTo = new Date();
            if(this.mobile){
                document.getElementById("mobile").value = null;
                this.mobile = "";
                this.selectedCharger = "0";
                this.selectedOutput = "0";
                this.chargerName = "All Charger Type"
                this.outputName = "All Outputs"
                this.outputs = [{ outputId: 0, outputName: "All Outputs" }];
                await this.getDateDaysAgo(this.configDays)
                await this.getDateMonthsAgo(this.configMonths)
                this.searchReport();
                this.reportType = "";
            }else if(this.vehicle) {
                this.selectedCharger = "0";
                this.selectedOutput = "0";
                this.chargerName = "All Charger Type"
                this.outputName = "All Outputs"
                this.outputs = [{ outputId: 0, outputName: "All Outputs" }];
                this.vehicle = "";
                this.invidualVhDetails = false;
                 this.searchReport();
                this.vehicleInd = true;
               
            }else {
                await this.getDateDaysAgo(this.configDays)
                await this.getDateMonthsAgo(this.configMonths)
                this.reportType = "";
                this.vehicle = "";
                
                this.vehicleInd = false;
                this.invidualVhDetails = false
                this.selectedReport = "UB";
                this.selectedCharger = "0";
                this.selectedOutput = "0";
                this.chargerName = "All Charger Type"
                this.outputName = "All Outputs"
                this.outputs = [{ outputId: 0, outputName: "All Outputs" }];
                this.searchReport();
            }
            
        },
        async loadPage(page) {
            // localStorage.setItem("cpoReservationPage", page);
            // alert(page+ "--"+this.totalRecords+"--"+this.pageRecords)
            this.loaderTab = true;
            this.pageNo = page;
            this.pagesList = new PaginationUtils().getPagesList(
                this.totalRecords,
                this.pageRecords,
                page
            );
            let to = this.pageRecords*page;
            let from = (this.pageRecords * (page -1));

            if(this.selectedReport == "UB" && this.mobile == "") {
                this.overAllPageData = this.overAllReport.reportData.slice(from, to);
            } else if(this.selectedReport == "UB" && this.mobile != "") {
                this.userBasedPageData = this.userBasedReport.reportData.slice(from, to);
            } else if(this.selectedReport == "VB" && this.vehicle == "") {
                this.overAllPageData = this.overAllReport.reportData.slice(from, to);
            } else if(this.selectedReport == "VB" && this.vehicle != "") {
                this.userBasedPageData = this.userBasedReport.reportData.slice(from, to);
            }
            
            // if(this.mobile == '') {
            //     this.overAllPageData = this.overAllReport.reportData.slice(from, to);
            // } else {
            //     this.userBasedPageData = this.userBasedReport.reportData.slice(from, to);
            // }

            // if(this.vehicle == '') {
            //     this.overAllPageData = this.overAllReport.reportData.slice(from, to);
            // } else {
            //     this.userBasedPageData = this.userBasedReport.reportData.slice(from, to);
            // }

            this.loaderTab = false;
        },
    },
})
</script>

<style scoped>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
.btn-srch-clr{
    margin-top: 22px;
}
.export-report{
    /* width: 52%;
    margin-left: 20%; */
}
.totalSection{
    /* background-color: #ededed; */
    margin-top: 20px;
    font-weight: bold;
}
.ext-link{
    color: black;
    cursor: auto;
}
.no-records{
    margin-top: 110px;
    /* background-color: #6777a2; */
}
.txt-color{
    font-size: 16px;
}
</style>
